import React from 'react';

const EmailVerificationSection = () => {
  return (
    <section style={{
      background: '#0A1220',
      padding: '80px 5%',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '1px solid rgba(255,255,255,0.06)'
    }}>
      {/* Accent line */}
      <div style={{
        position: 'absolute', top: 0, right: '30%', width: '1px',
        height: '100%', background: 'rgba(232,148,26,0.06)',
        transform: 'rotate(-5deg)', transformOrigin: 'top center',
        pointerEvents: 'none'
      }} />
      <div style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0,1.1fr) minmax(0,0.9fr)',
          gap: '64px',
          alignItems: 'center'
        }}>
          {/* Left: verification card */}
          <div style={{
            background: 'rgba(59,111,212,0.06)',
            border: '1px solid rgba(59,111,212,0.2)',
            padding: '48px',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Top gradient bar */}
            <div style={{
              position: 'absolute', top: 0, left: 0, right: 0, height: '3px',
              background: 'linear-gradient(90deg, #3B6FD4, transparent)'
            }} />

            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
              <div style={{ width: '32px', height: '1px', background: '#3B6FD4' }} />
              <span style={{
                fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6rem',
                color: '#3B6FD4', letterSpacing: '0.25em', textTransform: 'uppercase'
              }}>E-POSTBEKREFTELSE</span>
            </div>

            <h2 style={{
              fontFamily: 'Impact, Arial Black, sans-serif',
              fontSize: 'clamp(28px, 3.5vw, 48px)',
              fontWeight: 900, color: '#EEF0F2',
              lineHeight: 0.92, letterSpacing: '-0.02em',
              textTransform: 'uppercase',
              marginBottom: '8px'
            }}>SJEKK</h2>
            <h2 style={{
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: 'clamp(24px, 3vw, 40px)',
              fontWeight: 700, color: '#3B6FD4',
              lineHeight: 0.95, letterSpacing: '-0.01em',
              marginBottom: '28px'
            }}>innboksen din.</h2>

            <p style={{
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: '1rem', color: 'rgba(238,240,242,0.65)',
              lineHeight: 1.75, marginBottom: '28px'
            }}>
              Vi har sendt deg en bekreftelsesmelding til e-postadressen du oppga. Klikk på lenken i e-posten for å aktivere abonnementet ditt.
            </p>

            {/* Steps */}
            {[
            { num: '01', text: 'Åpne bekreftelsesmailen fra NordPass' },
            { num: '02', text: 'Klikk på bekreftelseslenken' },
            { num: '03', text: 'Abonnementet ditt er aktivert!' }]?.
            map((step) =>
            <div key={step?.num} style={{
              display: 'flex', alignItems: 'flex-start', gap: '16px',
              marginBottom: '16px'
            }}>
                <div style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.65rem', color: '#E8630A',
                letterSpacing: '0.1em', minWidth: '24px',
                paddingTop: '2px'
              }}>{step?.num}</div>
                <div style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.9rem', color: 'rgba(238,240,242,0.7)',
                lineHeight: 1.5
              }}>{step?.text}</div>
              </div>
            )}

            <div style={{
              marginTop: '28px',
              padding: '14px 20px',
              background: 'rgba(232,99,10,0.08)',
              border: '1px solid rgba(232,99,10,0.2)',
              display: 'inline-block',
              transform: 'rotate(-0.5deg)'
            }}>
              <span style={{
                fontFamily: 'Georgia, serif', fontStyle: 'italic',
                fontSize: '0.8rem', color: 'rgba(232,99,10,0.8)',
                letterSpacing: '0.02em'
              }}>Ikke funnet? Sjekk søppelpostmappen din.</span>
            </div>
          </div>

          {/* Right: decorative polaroid */}
          <div style={{ position: 'relative' }}>
            <div style={{
              position: 'relative',
              background: '#EEF0F2',
              padding: '16px 16px 48px',
              transform: 'rotate(2.5deg)',
              boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
              maxWidth: '340px',
              margin: '0 auto'
            }}>
              <img
                src="https://images.unsplash.com/photo-1635159469252-8cbf388015e2"
                alt="Snow-capped Norwegian mountain peaks reflected in a calm fjord with dramatic clouds overhead"
                style={{
                  width: '100%',
                  height: '220px',
                  objectFit: 'cover',
                  display: 'block',
                  filter: 'saturate(0.85) contrast(1.05)'
                }} />
              
              <div style={{
                position: 'absolute', top: '12px', right: '12px',
                background: '#3B6FD4',
                padding: '4px 10px'
              }}>
                <span style={{
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.55rem', color: '#EEF0F2',
                  letterSpacing: '0.15em', textTransform: 'uppercase'
                }}>BEKREFTET</span>
              </div>
              <div style={{
                marginTop: '16px', textAlign: 'center',
                fontFamily: 'Georgia, serif', fontStyle: 'italic',
                fontSize: '0.85rem', color: '#1a1a2e',
                letterSpacing: '0.02em'
              }}>Norges veier. Din kontroll.</div>
            </div>

            {/* Floating badge */}
            <div style={{
              position: 'absolute', bottom: '-20px', left: '0',
              background: '#E8630A',
              padding: '10px 18px',
              transform: 'rotate(-4deg)',
              zIndex: 2
            }}>
              <span style={{
                fontFamily: 'Impact, Arial Black, sans-serif',
                fontSize: '0.75rem', color: '#EEF0F2',
                letterSpacing: '0.1em', textTransform: 'uppercase'
              }}>ABONNERT ✓</span>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default EmailVerificationSection;